import { matchPath } from 'react-router';

export const PUSH_HISTORY_PAGE_TITLE = 'Notifications history';
export const ACCOUNT_PAGE_TITLE = 'Pricing';
export const CARD_PAGE_TITLE = 'Reward Card';

const MOBILE_HEADER_TITLES: Record<string, string> = {
  '/account/limits_trial': '',
  '/account/limits': '',
  '/account/profile': 'Profile settings',
  '/account/plan': 'Plan details',
  '/account/tariffs': ACCOUNT_PAGE_TITLE,
  '/account/contact-us': 'Feedback form',
  '/account/:cardId': CARD_PAGE_TITLE,
  '/account/:cardId/push_notification': 'Create push',
  '/account/:cardId/push_notification/history': PUSH_HISTORY_PAGE_TITLE,
  '/account/:cardId/push_notification/create': 'Create push',
  '/account/:cardId/push_notification/template': 'Push-notification',
  '/account/:cardId/push_notification/template/:templateId/create':
    'Create push',
  '/account/:cardId/push_notification/confirm/:templateId': 'Push-notification',
  'account/qr_code/:cardId': '',
};

export const resolveTitle = (pathname: string): string => {
  for (const [pattern, title] of Object.entries(MOBILE_HEADER_TITLES)) {
    if (matchPath(pattern, pathname)) {
      return title;
    }
  }
  return '';
};
